import { apiRequest } from "./api";

// Maps the wizard's pay object (src/context/AppContext.jsx: { method, routing, account,
// accountType }) onto the backend's PaymentRequest shape. A blank
// account means "keep the previously saved one unchanged" - see PaymentServiceImpl.
function toRequestBody(pay) {
  const body = { method: pay.method };
  if (pay.method === "efw") {
    body.bankRouting = pay.routing || "";
    body.bankAccount = pay.account || "";
    body.accountType = pay.accountType || "";
  }
  return body;
}

// Maps a PaymentResponse back onto the wizard's pay object shape. The API
// returns the real account number in full (PaymentResponse.bankAccount,
// masking removed 2026-08-14) - "account" is prefilled with it directly.
function fromResponseBody(response) {
  return {
    method: response.method || "",
    routing: response.bankRouting || "",
    account: response.bankAccount || "",
    accountType: response.accountType || "",
  };
}

// GET /returns/{returnId}/payment -> the previously saved payment choice, if any.
export async function getPayment(returnId) {
  const data = await apiRequest(`/returns/${returnId}/payment`);
  return fromResponseBody(data);
}

// POST /returns/{returnId}/payment -> creates or replaces the payment choice for this return.
export async function savePayment(returnId, pay) {
  const data = await apiRequest(`/returns/${returnId}/payment`, {
    method: "POST",
    body: toRequestBody(pay),
  });
  return fromResponseBody(data);
}
